<div class="max-h-[90vh]" data-testid="custom-update-modal">
  <h3 nxHeadline class="nx-font-weight-semibold" size="m">
    @if (data.controllerI18n | translate; as controlName) {
      {{ 'update.modal.title' | translate: { controlName } }}
    }
  </h3>
  <div class="mt-3">
    <span class="nx-font-weight-semibold">{{ 'update.modal.date' | translate }}</span> {{ todaysDate }}
  </div>
  @if (isEsgScoringToolEnabled()) {
    <nx-message context="info" class="mt-7 nx-margin-bottom-m">
      <span class="mr-3">{{ 'custom-update.sensitive-business.info.esg-scoring' | translate }} </span>
      <nx-link size="small"
        ><a href="{{ ESG_SCORING_LINK }}" target="_blank" rel="noopener">{{
          'custom-update.sensitive-business.info.esg-scoring.link-label' | translate
        }}</a></nx-link
      >
    </nx-message>
    <form class="mt-3" [formGroup]="updateForm">
      <nx-radio-group name="checkResponse" formControlName="checkResponse">
        <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold">{{
          'update.modal.sensitive-business-esg-scoring-question' | translate
        }}</nx-label>
        <nx-radio labelSize="small" value="reject" class="nx-margin-bottom-m">{{
          'update.modal.yes-escalate' | translate
        }}</nx-radio>
        <nx-radio labelSize="small" value="accept">{{ 'update.modal.no' | translate }}</nx-radio>
      </nx-radio-group>
      <nx-formfield class="mt-3" [label]="'escalate.modal.comment-optional' | translate">
        <textarea rows="5" spellcheck="false" nxInput [(ngModel)]="comment" type="text"></textarea>
      </nx-formfield>
      @if (updateForm.value.checkResponse === 'reject') {
        <nx-formfield [label]="'escalate.modal.esg-gerl.quiz-comment' | translate">
          <textarea nxInput rows="12" spellcheck="false" formControlName="esgQuizComment" type="text"></textarea>
        </nx-formfield>
      }
    </form>
    <kyc-file-uploader
      [showOptional]="false"
      [value]="documents"
      (filesChange)="onFilesChange($event)"
      (fileDeletion)="onFileDeletion($event)"
    />
  } @else {
    <form [formGroup]="esgQuizForm">
      <nx-label size="small" class="whitespace-pre-line" id="label-SECTOR">
        {{ 'esg.quiz.sensitiveBusiness.sector.title' | translate }}
      </nx-label>
      <nx-formfield appearance="outline">
        <nx-dropdown
          [placeholder]="'esg.quiz.sensitiveBusiness.sector.placeholder' | translate"
          formControlName="sector"
          ariaLabelledBy="label-SECTOR"
          (selectionChange)="sectorChanged($event)"
        >
          @for (sector of sectors(); track $index) {
            <nx-dropdown-item [value]="sector.code">{{ sector.i18n | translate }}</nx-dropdown-item>
          }
        </nx-dropdown>
      </nx-formfield>
      @if (esgQuizForm.value.sector && esgQuizForm.value.sector !== 'NONE') {
        <nx-radio-group name="question" formControlName="question" [required]="true">
          <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold">
            {{ 'esg.quiz.sensitiveBusiness.question' | translate }}
          </nx-label>
          <nx-radio labelSize="small" value="reject" class="nx-margin-bottom-m">{{
            'update.modal.yes-escalate' | translate
          }}</nx-radio>
          <nx-radio labelSize="small" value="accept">{{ 'update.modal.no' | translate }}</nx-radio>
        </nx-radio-group>
        @if (esgQuizForm.value.question === 'reject') {
          <nx-formfield [label]="'escalate.modal.esg-gerl.quiz-comment' | translate">
            <textarea nxInput rows="12" spellcheck="false" formControlName="esgQuizComment" type="text"></textarea>
          </nx-formfield>
        }
      }
      @if (esgQuizForm.value.sector === 'NONE') {
        <nx-message context="info" class="mt-7" data-testid="none-selected-message">
          {{ 'esg.quiz.notifications.none-selected' | translate }}
        </nx-message>
      }
    </form>
  }
  @if (updateForm.value.checkResponse === 'reject' && data.notifications.length) {
    <kyc-notifications-group [notifications]="data.notifications" />
  }
  <div class="flex justify-center mt-7">
    <button (click)="submit()" [disabled]="isSubmitDisabled" nxButton="small-medium" type="button">
      @if (loading) {
        <nx-spinner />
      } @else {
        {{ 'update.modal.button.submit' | translate }}
      }
    </button>
  </div>
  <div class="flex justify-center mt-3.5">
    <button (click)="data.closeModal()" [disabled]="loading" nxButton="tertiary small-medium" type="button">
      {{ 'update.modal.button.dismiss' | translate }}
    </button>
  </div>
</div>
